import client from "../utils/client";
import { ordersUrl } from "../store/constants/api";
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const orderService = {
  ordersList,
  orderData,
  orderPayments,
  orderUpdate,
};

function ordersList(
  pageID,
  perPage,
  searchInput,
  startDate,
  endDate,
  operatorId
) {
  let searchQuery = "";
  if (searchInput !== "") {
    searchQuery = "&search=" + searchInput;
  }
  if (operatorId) {
    searchQuery += "&operator_id=" + operatorId;
  }
  return client
    .get(
      ordersUrl +
        "?page=" +
        pageID +
        "&per_page=" +
        perPage +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate +
        searchQuery
    )
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function orderData(orderID) {
  return client
    .get(ordersUrl + "/" + orderID + "/show")
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function orderPayments(orderID) {
  return client
    .get(ordersUrl + "/" + orderID + "/payments")
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function orderUpdate(orderID, newStatus) {
  return client
    .post(ordersUrl + "/update-status", { id: orderID, status: newStatus })
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
